import Vue from 'vue';
import { notificationErrorText } from '@/utils/PortalConstants';

interface NotifyOptions {
  group?: string;
  title?: string;
  text?: string;
  type?: string;
  duration?: number;
}

const paramsDefault = {
  group: 'network',
  title: '',
  text: notificationErrorText,
  type: 'warn',
  duration: -1,
};

export function showNotification(params: NotifyOptions) {
  const newParams = { ...paramsDefault, ...params };
  Vue.notify(newParams);
}

export function notifyNetworkError(notifyOptions: NotifyOptions) {
  showNotification({ ...notifyOptions, ...{ type: 'warn' } });
}

export function notifyNetworkSuccess(notifyOptions: NotifyOptions) {
  showNotification({ ...{ type: 'success', duration: 3000 }, ...notifyOptions });
}
